import { render, staticRenderFns } from "./OwnersDeleteModal.vue?vue&type=template&id=52ea3180&scoped=true&"
import script from "./OwnersDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./OwnersDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./owners-delete-modal.scss?vue&type=style&index=0&id=52ea3180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea3180",
  null
  
)

export default component.exports